import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../../components/header";
import Footer from "../../components/footer";
import AddNewDropdown from "../../components/AddNewResearch";
import AdminImg from "../../assets/admin.png";
import "./UserProfile.css";
import axios from "axios";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const UserProfile = () => {
  const { id } = useParams();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [selectedTab, setSelectedTab] = useState("publications");
  const [isFollowing, setIsFollowing] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);

  const token = localStorage.getItem("access_token");

  useEffect(() => {
    const fetchCurrentUserAndCheckFollowing = async () => {
      try {
        const profileRes = await fetch(
          `${BASE_URL}/user/profile/create-profile/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "x-api-key": process.env.REACT_APP_X_API_KEY,
            },
          }
        );
        const profileData = await profileRes.json();
        const currentId = profileData?.data?.id;
        setCurrentUserId(currentId);
        if (currentId && currentId !== id) {
          const followRes = await axios.get(
            `${BASE_URL}/user/follow-unfollow/follow/`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "x-api-key": process.env.REACT_APP_X_API_KEY
              },
            }
          );
          const followedUsers = followRes.data?.results || [];
          // const isFollowed = followedUsers.some(
          //   (user) => String(user.follow_user_profile?.id) === String(id)
          // );
          const isFollowed = followedUsers.some(
            (user) => String(user.follow_user_profile?.user) === String(id)
          );


          setIsFollowing(isFollowed);
        }
      } catch (err) {
        console.error("Error checking follow status", err);
      }
    };
    if (token) {
      fetchCurrentUserAndCheckFollowing();
    }
  }, [id, token]);

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const res = await fetch(
          `${BASE_URL}/user/profile/all-profiles/?id=${id}`,
          {
            headers: { Authorization: `Bearer ${token}`, "x-api-key": process.env.REACT_APP_X_API_KEY },
          }
        );
        const data = await res.json();
        if (res.ok) {
          setProfile(data.data);
        } else {
          console.error("Failed to fetch user profile");
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, [id, token]);

  const handleFollowToggle = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "x-api-key": process.env.REACT_APP_X_API_KEY
      };
      if (isFollowing) {
        const res = await axios.delete(
          `${BASE_URL}/user/follow-unfollow/follow/`,
          {
            headers,
            data: { id },
          }
        );
        if (
          res.status === 204 ||
          res.data?.message === "Successfully unfollowed."
        ) {
          toast.success("Unfollowed successfully");
          setIsFollowing(false);
        }
      } else {
        const res = await axios.post(
          `${BASE_URL}/user/follow-unfollow/follow/`,
          { id },
          { headers }
        );
        if (res.data?.message === "Successfully followed") {
          toast.success("Followed successfully");
          setIsFollowing(true);
        } else if (res.data?.error === "You are already following this user.") {
          toast.info("Already following");
          setIsFollowing(true);
        }
      }
    } catch (err) {
      toast.error("Something went wrong");
      console.error("Follow/Unfollow Error:", err);
    }
  };

  if (loading) {
    return (
      <div className="loading-spinner-container">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  if (!profile) return <div>User not found.</div>;

  return (
    <>
      <Header />
      <div className="user-profile-tabs-container">
        <div className="user-profile-header">
          <div className="user-profile-image-wrapper">
            <img
              src={profile.profile_picture || AdminImg}
              alt={profile.name}
              className="user-profile-image"
            />
          </div>
          <div className="user-profile-details">
            <h2>{profile.name}</h2>
            <p>
              <strong>Institution:</strong> {profile.institution}
            </p>
            <p>
              <strong>Affiliation:</strong> {profile.primary_affiliation}
            </p>
            <p>
              <strong>Degree:</strong> {profile.degree}
            </p>
            <p>
              <strong>Research Areas:</strong> {profile.research_areas}
            </p>
            <p>
              <strong>Activity:</strong> {profile.current_activity}
            </p>
            <p>
              <strong>Bio:</strong> {profile.bio}
            </p>
          </div>
          {currentUserId && String(currentUserId) !== String(id) && (
            <button className="follow-button" onClick={handleFollowToggle}>
              {isFollowing ? "Following" : "Follow"}
            </button>
          )}{" "}
        </div>
        {/* Tabs Navigation */}
        <div className="user-tabs">
          {["publications", "gallery", "videos", "code", "portfolio"].map(
            (tab) => (
              <button
                key={tab}
                className={`user-tab ${selectedTab === tab ? "active" : ""}`}
                onClick={() => setSelectedTab(tab)}
              >
                {tab.charAt(0).toUpperCase() + tab.slice(1)}
              </button>
            )
          )}
        </div>
        {/* Tab Content */}
        <div className="user-profile-tab-content">
          {selectedTab === "publications" && (
            <>
              <h3>Publications</h3>
              <ul>
                {profile.publications.map((pub) => (
                  <li key={pub.id}>{pub.title}</li>
                ))}
              </ul>
            </>
          )}
          {selectedTab === "gallery" && (
            <>
              <h3>Gallery</h3>
              <div className="gallery">
                {profile.gallery_images.map((img) => (
                  <img
                    key={img.id}
                    src={img.image}
                    alt="Gallery"
                    className="gallery-img"
                  />
                ))}
              </div>
            </>
          )}
          {selectedTab === "videos" && (
            <>
              <h3>Videos</h3>
              {profile.videos.map((video) => (
                <video
                  key={video.id}
                  controls
                  width="300"
                  style={{ marginRight: "10px", marginBottom: "10px" }}
                >
                  <source src={video.video} type="video/mp4" />
                </video>
              ))}
            </>
          )}
          {selectedTab === "code" && (
            <>
              <h3>Code Contributions</h3>
              {profile.user_codes.map((code) => (
                <div key={code.id} className="code-snippet">
                  <p>
                    <strong>{code.title}</strong> ({code.code_of})
                  </p>
                  <pre>{code.code}</pre>
                </div>
              ))}
            </>
          )}
          {selectedTab === "portfolio" && (
            <>
              <h3>Internships</h3>
              {profile.internships.map((intern) => (
                <div key={intern.id} className="card">
                  <p>
                    <strong>{intern.title}</strong> at {intern.company}
                  </p>
                  <p>
                    {intern.start_month} {intern.start_year} –{" "}
                    {intern.end_month} {intern.end_year}
                  </p>
                  <p>{intern.description}</p>
                  <a
                    href={intern.media}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View Certificate
                  </a>
                </div>
              ))}
              <h3>Projects</h3>
              {profile.projects.map((project) => (
                <div key={project.id} className="card">
                  <p>
                    <strong>{project.project_name}</strong>
                  </p>
                  <p>{project.description}</p>
                  <p>
                    <strong>Skills:</strong> {project.skills}
                  </p>
                  <a
                    href={project.media}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View File
                  </a>
                </div>
              ))}
              <h3>Education</h3>
              {profile.education.map((edu) => (
                <div key={edu.id} className="card">
                  <p>
                    <strong>{edu.school}</strong> - {edu.degree}
                  </p>
                  <p>
                    {edu.start_Year} to {edu.end_Year}
                  </p>
                  <p>
                    {edu.field_study} | Grade: {edu.grade}
                  </p>
                  <p>{edu.description}</p>
                  <a href={edu.media} target="_blank" rel="noopener noreferrer">
                    View Doc
                  </a>
                </div>
              ))}
            </>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default UserProfile;
